import React from 'react';
import T from 'prop-types';
import { connect } from 'react-redux';
// components
import SingleDatePicker from 'components/DatePicker/SingleDatePicker/SingleDatePicker';
// regional date handling
import { getCurrentCountryCode } from 'selectors/regionalDateSelectors';
import { getInputPlaceholder } from 'utils/regionalDateHelper';

const DatePickerField = ({
  input,
  label,
  meta: { touched, error },
  className,
  countryCode,
  ...others
}) => {
  const regionalPlaceholder = getInputPlaceholder(countryCode);

  return (
    <div className={className + (touched && error ? 'has-error' : '')}>
      <div className="row">
        <div className="small-12 medium-3 column label-wrapper">{label}</div>
        <div className="small-12 medium-9 column input-wrapper">
          <SingleDatePicker
            {...input}
            {...others}
            date={input.value || null}
            onDateChange={input.onChange}
            inputLabel={regionalPlaceholder}
          />
        </div>
      </div>
    </div>
  );
};

DatePickerField.propTypes = {
  input: T.object.isRequired,
  label: T.node,
  meta: T.object.isRequired,
  className: T.string,
  countryCode: T.string,
};

DatePickerField.defaultProps = {
  countryCode: 'US',
};

export default connect(
  (state) => ({
    countryCode: getCurrentCountryCode(state)
  })
)(DatePickerField);
